import React, { useEffect } from "react";
import {
  MdOutlineCalendarToday,
  MdOutlineMedicalServices,
  MdOutlineDescription,
  MdOutlineAccessTime,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { useLazyGetpatientoverviewcardsQuery, useLazyGetpatientoverviewQuery } from "../../State/Api/AddpatientApiSlice";

const PatientOverview = ({patientUserUniqueID,medicalInfo,basicInfo}) => {
  const clinicUserId = localStorage.getItem("userClinicID");
  const navigate=useNavigate();
    const [
        fetchpatientAppointments,
        { data: patientappointmentData = [], isFetching },
      ] = useLazyGetpatientoverviewQuery();
    
     useEffect(() => {
    if (patientUserUniqueID,clinicUserId) {
      fetchpatientAppointments(patientUserUniqueID);
    }
  }, [patientUserUniqueID]);
  
const [
  fetchpatientcards,
  { data: patientoverviewData = [], isLoading },
] = useLazyGetpatientoverviewcardsQuery();

  useEffect(() => {
    if (patientUserUniqueID,clinicUserId) {
      fetchpatientcards({patientUserUniqueID,clinicUserId});
    }
  }, [patientUserUniqueID,clinicUserId]);

  const latestAppointment = patientoverviewData?.find(item => item.category === "Latest Appointment");
const latestReports = patientoverviewData?.find(item => item.category === "Latest Reports");
const prescription = patientoverviewData?.find(item => item.category === "Prescription");

const formatDate = (dateString) => {
  if (!dateString) return "No Data";
  return new Date(dateString)
    .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    .replace(/ /g, "-");
};


  return (
    <div className="mt-2 space-y-4">
      {/* Patient Summary */}
      <div className="rounded-lg border bg-white text-black shadow-sm">
        <div className="flex flex-col space-y-1.5 p-4">
          <h2 className="text-xl xl:text-12xl
          font-semibold leading-tight mb-2 tracking-tight">
            Patient Summary
          </h2>
          <p className="text-sm text-gray-500">
            Overview of patient's health status and recent activities.
          </p>
        </div>

        <div className="p-4 space-y-6">
          {/* Summary Boxes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  {/* Next Appointment */}
  <SummaryBox
    icon={<MdOutlineCalendarToday className="mr-2 h-4 w-4" />}
    title="Next Appointment"
    lines={[
      formatDate(latestAppointment?.dates),
      `${latestAppointment?.times || ""} • ${latestAppointment?.appointmentType || ""}`,
      latestAppointment?.textValue || "No Doctor"
    ]}
  />

  {/* Active Medications (Prescription) */}
  <SummaryBox
    icon={<MdOutlineMedicalServices className="mr-2 h-4 w-4" />}
    title="Active Medications"
    lines={[
      prescription?.textValue || "No Prescriptions",
      `Last updated: ${formatDate(prescription?.dates)}`
    ]}
    action="View all medications"
  />

  {/* Recent Lab Results */}
  <SummaryBox
    icon={<MdOutlineDescription className="mr-2 h-4 w-4" />}
    title="Recent Lab Results"
    lines={[
      latestReports?.appointmentType || "No Report Type",
      formatDate(latestReports?.dates)
    ]}
    action="View results"
  />
</div>


          {/* Recent Appointments */}
          <div className="space-y-4">
  <h3 className="text-lg font-medium">Recent Appointments</h3>
  <div className="space-y-3">
   {patientappointmentData.filter((appointment) => appointment.status === "Completed").slice(0, 3).map((appointment, index) => {
  const formattedDate = new Date(appointment.appointmentDate)
  .toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
  .replace(/ /g, "-");


  return (
    <AppointmentCard
      key={index}
      title={appointment.appointmentType}
      date={formattedDate}
      time={appointment.timeSlot}
      doctor={appointment.doctorName}
      status={appointment.status}
    />
  );
})}

  </div>
  {/* <button onClick={()=>navigate('/clinic/appointments')} className="text-[#171717] w-full h-10 px-4 py-2 text-sm font-medium border rounded-md bg-white hover:bg-gray-50">
    View All Appointments
  </button> */}
</div>

          {/* Vital Signs */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium">Vital Signs Trend</h3>
              {/* <button className="text-sm font-medium border bg-white hover:bg-gray-50 rounded-md px-3 h-9">
                View History
              </button> */}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 ">
              <VitalStat
                title="Blood Pressure"
                value={`${medicalInfo?.bloodPressure} mmHg`}
                status="Slightly elevated"
                percent={70}
                color="bg-amber-500"
                 date={basicInfo?.updateddate}
              />
              <VitalStat
                title="Pulse Rate"
                value={`${medicalInfo?.pulse} bpm`}
                status="Above normal"
                percent={65}
                color="bg-amber-500"
                 date={basicInfo?.updateddate}
              />
              <VitalStat
                title="Weight"
                value={`${medicalInfo?.weight} kg`}
                status="Stable"
                percent={50}
                color="bg-green-500"
                date={basicInfo?.updateddate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SummaryBox = ({ icon, title, lines, action }) => (
  <div className="rounded-lg border bg-white text-black shadow-sm">
    <div className="flex flex-col space-y-1.5 p-4 pb-2">
      <h2 className="text-base font-semibold tracking-tight flex items-center"  style={{fontSize:14}}>
        {icon} {title}
      </h2>
    </div>
    <div className="space-y-1 px-4 pb-4">
      {lines.map((line, idx) => (
        <p
          key={idx}
          className={`text-sm ${idx === 0 ? "font-medium" : "text-gray-500"}`}
        >
          {line}
        </p>
      ))}
      {/* {action && (
        <button className="text-sm text-blue-600 hover:underline font-medium">
          {action}
        </button>
      )} */}
    </div>
  </div>
);

const AppointmentCard = ({ title, date, time, doctor,status }) => (
  <div className="flex items-center justify-between p-3 border rounded-md flex-wrap gap-3">
    <div className="flex items-start gap-3">
      <div className="h-2 w-2 mt-2 rounded-full bg-green-500"></div>
      <div>
        <p className="font-medium">{title}</p>
        <div className="flex items-center text-sm text-gray-500">
          <MdOutlineCalendarToday className="mr-1 h-3 w-3" /> {date}
          <MdOutlineAccessTime className="ml-2 mr-1 h-3 w-3" /> {time}
        </div>
        <p className="text-sm text-gray-500">{doctor}</p>
      </div>
    </div>
    <div className="inline-flex items-center rounded-full bg-green-500 text-white px-2.5 py-0.5 text-xs font-semibold">
      {status}
    </div>
  </div>
);

const VitalStat = ({ title, value, status, percent, color,date }) => (
  <div className="rounded-lg border bg-white text-black shadow-sm">
    <div className="flex flex-col space-y-1.5 p-4 pb-2">
      <h2 className="text-base xl:text-xl font-semibold mb-2 tracking-tight">
        {title}
      </h2>
    </div>
    <div className="p-4">
      <p className="text-xl font-bold">{value}</p>
      {date && !isNaN(new Date(date)) && (
  <p className="text-sm text-gray-500">
    Last checked:{" "}
    {new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-")}
  </p>
)}

      {/* <div className="mt-2 h-1 w-full bg-gray-200 rounded">
        <div className={`h-1 rounded ${color}`} style={{ width: `${percent}%` }}></div>
      </div> */}
      {/* <p className="text-xs mt-1 text-gray-600">{status}</p> */}
    </div>
  </div>
);

export default PatientOverview;
